<template>
  <div class="wrapper">
    <div class="searchBar">
      <div>
        <el-input
          placeholder="搜索学院姓名、证书名称、身份证号"
          v-model="searchCondition.search"
          size="small"
          style="width: 160px"
        ></el-input>
      </div>
      <div>
        <el-select
          placeholder="反馈类型"
          v-model="searchCondition.type"
          size="small"
        >
          <el-option value="" label="所有反馈类型"></el-option>
          <el-option value="1" label="投诉"></el-option>
          <el-option value="2" label="建议"></el-option>
          <el-option value="3" label="举报"></el-option>
        </el-select>
        &ensp;&ensp;&ensp;&ensp;
        <el-select
          placeholder="审核状态"
          v-model="searchCondition.status"
          size="small"
        >
          <el-option value="" label="所有审核状态"></el-option>
          <el-option value="0" label="待审核"></el-option>
          <el-option value="1" label="审核通过"></el-option>
          <el-option value="2" label="审核不通过"></el-option>
        </el-select>
        &ensp;&ensp;&ensp;&ensp;
        <el-date-picker
          type="date"
          placeholder="上传登记时间"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          size="small"
          v-model="searchCondition.createTime"
        >
        </el-date-picker>
        &ensp;&ensp;&ensp;&ensp;
        <el-button type="primary" size="small" @click="getData">查询</el-button>
      </div>
    </div>
    <div class="content">
      <div class="actBar">
        <el-button size="small">导出</el-button>
        <el-button size="small">导入</el-button
        ><el-button size="small">下载模板</el-button>
      </div>
      <div class="tableContainer">
        <el-table
          :data="dataList"
          border
          style="width: 100%"
          :cell-style="{ padding: '2px', fontSize: '14px' }"
        >
          <el-table-column type="index" width="40"></el-table-column>
          <el-table-column prop="userName" label="姓名" width="80px">
          </el-table-column
          ><el-table-column prop="mobile" label="手机号" width="120px">
          </el-table-column
          ><el-table-column prop="type" label="反馈类型" width="80px">
          </el-table-column
          ><el-table-column prop="content" label="投诉内容" width="180px">
          </el-table-column
          ><el-table-column label="图片" class-name="noPadding" width="110px">
            <template slot-scope="{ row }">
              <el-image
                fit="contain"
                :src="row.imageUrl"
                v-if="row.imageUrl"
                style="width: 80px; height: 80px"
                :preview-src-list="[row.imageUrl]"
              />
            </template> </el-table-column
          ><el-table-column prop="updateTime" label="处理时间">
          </el-table-column
          ><el-table-column prop="updateUser" label="处理人" width="100px">
          </el-table-column
          ><el-table-column prop="opinion" label="处理意见" width="100px">
          </el-table-column>
          <el-table-column
            label="创建时间"
            prop="createTime"
            width="160px"
          ></el-table-column>

          <el-table-column
            label="审核状态"
            width="100px"
            :formatter="
              (data) => ['未审核', '审核通过', '审核不通过'][data.status]
            "
          >
          </el-table-column
          ><el-table-column prop="" label="操作" width="100px">
            <template slot-scope="{ row }">
              <el-button type="primary" plain @click="showDetail(row)"
                >详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @current-change="getData"
          @size-change="getData"
          :current-page.sync="searchCondition.pageNumber"
          :page-sizes="[10, 30, 100]"
          :page-size.sync="searchCondition.pageSize"
          :total="searchCondition.total"
          layout="total, sizes, prev, pager, next, jumper"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="详情"
      :visible.sync="complaintDetail.ifShow"
      width="600px"
      :close-on-click-modal="false"
      append-to-body
      top="5vh"
    >
      <el-form
        :model="complaintDetail"
        label-width="100px"
        class="demo-ruleForm"
        width="60%"
      >
        <el-form-item label="姓名" prop="userName">
          <el-input v-model="complaintDetail.userName"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input v-model="complaintDetail.mobile"></el-input>
        </el-form-item>
        <el-form-item label="举报内容" prop="content">
          <el-input
            type="textarea"
            v-model="complaintDetail.content"
          ></el-input>
        </el-form-item>
        <el-form-item label="相关图片" prop="imageUrl">
          <el-image
            style="width: 200px; height: 200px"
            fit="contain"
            :src="complaintDetail.imageUrl"
          ></el-image>
        </el-form-item>
        <el-form-item label="处理意见" prop="opinion">
          <el-input
            type="textarea"
            v-model="complaintDetail.opinion"
          ></el-input>
        </el-form-item>
        <el-form-item label="审核状态" prop="status">
          <el-select v-model="complaintDetail.status" size="small">
            <el-option value="0" label="待审核"></el-option>
            <el-option value="1" label="审核通过"></el-option>
            <el-option value="2" label="审核不通过"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="complaintDetail.ifShow = false">取 消</el-button>
        <el-button type="primary" @click="editComplaint">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getComplaintsList, complaintsHandle } from "@/api/bus.js";
export default {
  data() {
    return {
      dataList: [],
      complaintDetail: {
        userName: "",
        mobile: "",
        content: "",
        imageUrl: "",
        status: 0,
        opinion: "",
        id: 0,
        ifShow: false,
      },
      searchCondition: {
        pageNumber: 1,
        status: "",
        pageSize: 10,
        search: "",
        createTime: "",
        type: "",
      },
    };
  },
  created() {},
  mounted() {
    this.getData();
  },
  methods: {
    editComplaint() {
      complaintsHandle(this.complaintDetail).then((data) => {
        console.log(data);
        this.complaintDetail.ifShow = false;
        this.getData();
      });
    },
    showDetail(item) {
      item.ifShow = true;
      Object.assign(this.complaintDetail, item);
    },
    getData() {
      let postData = {};
      Object.assign(postData, this.searchCondition);
      if (postData.status == "") {
        delete postData.status;
      }
      getComplaintsList(postData).then((data) => {
        this.dataList = data.rows;
        this.searchCondition.total = data.total;
        console.log(data);
      });
    },
  },
};
</script>

<style scoped lang="less">
.wrapper {
  .searchBar {
    padding: 15px;
    background: #fff;
    display: flex;
    justify-content: space-between;
  }
  .content {
    margin-top: 15px;
    background: #fff;
    padding: 15px;
    .actBar {
      margin-bottom: 10px;
    }
  }
}
.noPadding {
  padding: 0 !important;
  padding-left: 0;
  padding-right: 0;
}
</style>
